import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="min-h-screen bg-[#051A0F] flex items-center justify-center" data-testid="auth-loading">
        <Loader2 className="w-8 h-8 text-[#F0B91B] animate-spin" />
      </div>
    );
  }

  if (user === false) return <Navigate to="/login" replace />;

  if (roles && !roles.includes(user.role)) {
    return <Navigate to={user.role === "admin" ? "/admin" : "/dashboard"} replace />;
  }

  return children;
}
